import { render } from "./PublishPost.vue?vue&type=template&id=582ea73e&scoped=true"
import script from "./PublishPost.vue?vue&type=script&lang=js"
export * from "./PublishPost.vue?vue&type=script&lang=js"

import "./PublishPost.vue?vue&type=style&index=0&id=582ea73e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582ea73e"]])

export default __exports__